import createHashHistory from 'history/lib/createHashHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createHashHistory);


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/react-router/es/hashHistory.js
// module id = 164
// module chunks = 0